import * as React from "react";
import { forwardRef } from "react";
const SvgPeopleBlue = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 8C10.6569 8 12 6.65685 12 5C12 3.34315 10.6569 2 9 2C7.34315 2 6 3.34315 6 5C6 6.65685 7.34315 8 9 8Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M15 13.625C15 15.4887 15 17 9 17C3 17 3 15.4887 3 13.625C3 11.7613 5.6865 10.25 9 10.25C12.3135 10.25 15 11.7613 15 13.625Z", fill: "white" }));
const ForwardRef = forwardRef(SvgPeopleBlue);
export { ForwardRef as ReactComponent };
